import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { TP_COLORS } from '../../../../constants';
import {
  getSubjectColorNew,
  getSubjectIconName,
  getUrlConvertedString,
} from '../../../../helper';

import { ICurriculumForHome } from '../../../../store/CurriculumSlice';

interface SubjectSectionProps {
  selectedCurriculum: ICurriculumForHome;
}

const SubjectsSection: React.FC<SubjectSectionProps> = ({
  selectedCurriculum,
}) => {
  const navigate = useNavigate();

  const [isHover, setIsHover] = useState<number | undefined>(undefined);
  return (
    <Stack
      minWidth="300px"
      sx={{
        display: { xs: 'none', sm: 'flex' },
        margin: { md: '62px 0px 0px 30px' },
        maxWidth: { md: '300px' },
      }}
    >
      <Typography variant="h6" color={TP_COLORS.gray.dark}>
        Explore Subjects
      </Typography>

      <Grid container spacing={1} marginTop="10px">
        {selectedCurriculum.subjects.map((subjectItem, index) => {
          const subjectIndex = index + 1;

          const curriculum = getUrlConvertedString(
            selectedCurriculum ? selectedCurriculum.name : ''
          );
          const subject = getUrlConvertedString(subjectItem.name);
          const subjectLevel = getUrlConvertedString(subjectItem.subjectLevel);
          const subjectCode = getUrlConvertedString(subjectItem.subjectCode);

          const onHover = isHover && isHover === subjectIndex;
          const subjectColor = getSubjectColorNew(subjectItem.name);

          return (
            <Grid item key={subjectIndex} xs={12} sm={6} md={12}>
              <Card
                elevation={0}
                sx={{
                  backgroundColor: `${subjectColor}1A`,
                  borderRadius: '7px',
                  '&:hover': {
                    backgroundColor: subjectColor,
                  },
                }}
              >
                <CardActionArea
                  // onMouseEnter={() => setIsHover(subjectIndex)}
                  onMouseLeave={() => setIsHover(undefined)}
                  onMouseOver={() => setIsHover(subjectIndex)}
                  onClick={() =>
                    navigate(
                      `${process.env.PUBLIC_URL}/dashboard/${curriculum}/${subject}/${subjectLevel}/${subjectCode}`
                    )
                  }
                >
                  <CardContent>
                    <Stack direction="row" justifyContent="space-between">
                      <Box>
                        <Typography
                          variant="subtitle1"
                          className="ellipsis-text"
                          color={onHover ? TP_COLORS.white : subjectColor}
                        >
                          {subjectItem.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontSize="12px"
                          color={onHover ? TP_COLORS.white : '#475569'}
                        >
                          {subjectItem.subjectCode}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontSize="12px"
                          color={onHover ? TP_COLORS.white : '#475569'}
                        >
                          {subjectItem.subjectLevel}
                        </Typography>
                      </Box>
                      <img
                        src={`${
                          process.env.PUBLIC_URL
                        }/images/landingPage/icon-${getSubjectIconName(
                          subjectItem.name
                        )}${onHover ? '-white' : ''}.avif`}
                        alt="subject-img"
                        style={{ height: '64px' }}
                      />
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};

export default SubjectsSection;
